import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwzpxs324m: FaireProductEntity = {
  token: "p_wwzpxs324m",
  type: "product",
  name: "Pure Heat Gourmet Sauce",
  brandToken: "b_ht8e33rg3g",
  brandName: "Pure Heat Gourmet Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/0d898a00987225eb3397dab8e4d909e19e4901c15a9f172e6fe175ee5c995791.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96ca33951b4a4f1cfa536a1b7e587170caf32d5f16107ed9bb8e90b1c5218ad7.jpeg",
    "https://cdn.faire.com/fastly/20e9b8357c3e1eece6c667653b071336df6d71eedc84a4a34df46f0cb125bc73.jpeg",
    "https://cdn.faire.com/fastly/edd894526b07b5a53a8b8643c305f2e0112410a93cb10431f95283276f8b5a9b.jpeg",
  ],
  priceDollars: 5,
  description:
    "Pure Heat is not a hot sauce, it's not a BBQ sauce, it's an all sauce. Goes great on anything, and has a perfect mix of flavor and heat.",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:23.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
